/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DataGrid from "../input/DataGrid";
import AutoDataGridColumn from "./AutoDataGridColumn";

function AutoDataGrid ( props ) {

    const { t } = useTranslation ();

    const { id, schema, onUpdatedView, onInitialized, children, ...others } = props;
    
    const [ grid, setGrid ] = useState ();
    const [ orderedColumns, setOrderedColumns ] = useState([]);
    const [ , setStorageKey ] = useState();
    const [ , setColumnMap ] = useState ();

    useEffect ( () => {

        let orderedColumns = schema ? schema.columns.slice().filter ( ( column ) => ( column.grid ? ! column.grid.hide : true ) ) : [];

        // make column map;

        let columnMap = {};

        for ( const column of orderedColumns ) {

            columnMap[column.name] = column;

        }
        
        setColumnMap ( columnMap );

        if ( schema && grid ) {

            let storageKey = `grid-${id}-layout`;

            setStorageKey ( storageKey );

            // restore column layout

            let layoutString = localStorage.getItem ( storageKey );

            let layout = JSON.parse ( layoutString );

            if ( layout ) {

                let layoutColumns = layout.columns;

                for ( const index in layoutColumns ) {

                    let column = columnMap[layoutColumns[index].name];

                    if ( column ) {

                        if ( column.grid ) {

                            column.grid.width = layoutColumns[index].width;
                            column.grid.columnOrder = index;
                            column.grid.visible = layoutColumns[index].visible;
    
                        } else {

                            column.grid = {};
                            column.grid.width = layoutColumns[index].width;
                            column.grid.columnOrder = index;
                            column.grid.visible = layoutColumns[index].visible;

                        }

                    }

                }
                    
            }

        }

        setOrderedColumns ( orderedColumns );

    }, [grid, schema] );

    const saveLayout = ( grid ) => {

        if ( grid.columnLayout ) {

            let layout = JSON.parse ( grid.columnLayout );

            if ( layout.columns.length > 0 ) {

                setStorageKey ( ( storageKey ) => {

                    localStorage.setItem ( storageKey, grid.columnLayout );
    
                    return ( storageKey );
    
                })
    
            }

        }

    };

    const onAutoGridInitialized = ( grid ) => {

        grid.headersVisibility = "Column";

        grid.copying.addHandler ( ( grid, event ) => {

            setColumnMap ( ( columnMap ) => {

                let column = columnMap[grid.columns[event.col].name];

                let value = grid.getCellData( event.row, event.col ) 

                if ( column.grid.type === 'select' || column.grid.type === 'approvalState' ) {

                    let found = column.selectItems.find ( ( item ) => parseInt ( item.value ) === parseInt ( value ) );
                    
                    value = found ? t( found.name ) : value;

                }

                navigator.clipboard.writeText  ( value );
    
                return columnMap;

            } );

            return false;

        }) ;

        setGrid ( grid );

        if ( onInitialized ) {

            onInitialized ( grid );

        }

    };

    const onDataGridUpdatedView = ( grid, e ) => {

        if ( grid ) 
        {

            setTimeout ( () => {

                saveLayout ( grid );
                    
                if ( onUpdatedView ) {
    
                    onUpdatedView ( grid, e );
    
                }
    
            }, 0 )
    
        }

    };

    return (

        <>
            <DataGrid id={id} schema={schema} onInitialized={onAutoGridInitialized} onUpdatedView={ ( e ) => onDataGridUpdatedView ( grid, e ) } {...others}>

                {

                    orderedColumns
                        .slice()
                        .sort( ( columnA, columnB ) => ( ( columnA.grid && columnB.grid ) ? columnA.grid.columnOrder - columnB.grid.columnOrder : 0 ) )
                        .map ( ( column ) => <AutoDataGridColumn key={id + column.name} schema={column} /> )

                }

            </DataGrid>
        </>

    );
}

export default AutoDataGrid;

